import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface GwStateIF {
  gwName: string;
}

const initialState = {
  gwName: "",
} as GwStateIF;

const gwInfoSlice = createSlice({
  name: "gwInfo",
  initialState,
  reducers: {
    showGwInfoModal: (
      state,
      action: PayloadAction<{
        gwName: string;
      }>
    ) => {
      const { gwName } = action.payload;
      state.gwName = gwName;
    },
  },
});

export const { showGwInfoModal } = gwInfoSlice.actions;

export default gwInfoSlice.reducer;
